// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3Kabf","thPhone":"styles_thPhone__2Vj55"};